import { render, staticRenderFns } from "./TrainingMyPath.vue?vue&type=template&id=056d0921"
import script from "./TrainingMyPath.vue?vue&type=script&lang=js"
export * from "./TrainingMyPath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports